export const initAssets = [
  'brand/anim/skeleton.json',
  'atlases/init-0.json',
  'atlases/init-1.json',
]
export const splashAssets = [
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/back-fs/skeleton.json',
  'animations/spine/back-reg/sleleton.json',
  'animations/spine/bonus-names/skeleton.json',
  'animations/spine/bonus-names-sc/skeleton.json',
  'animations/spine/bonus_game_anims/lamp/skeleton.json',
  'animations/spine/bonus_game_anims/shots/skeleton.json',
  'animations/spine/buyFeature-sc/skeleton.json',
  'animations/spine/buyfeature/skeleton.json',
  'animations/spine/gunchoose/skeleton.json',
  'animations/spine/gunchoose-sc/skeleton.json',
  'animations/spine/items/1/skeleton.json',
  'animations/spine/items/2/skeleton.json',
  'animations/spine/items/A/skeleton.json',
  'animations/spine/items/B/skeleton.json',
  'animations/spine/items/C/skeleton.json',
  'animations/spine/items/D/skeleton.json',
  'animations/spine/items/E/skeleton.json',
  'animations/spine/items/F/skeleton.json',
  'animations/spine/items/G/skeleton.json',
  'animations/spine/items/H/skeleton.json',
  'animations/spine/items/I/skeleton.json',
  'animations/spine/items/J/skeleton.json',
  'animations/spine/logo/win/skeleton.json',
  'animations/spine/multiplier/skeleton.json',
  'animations/spine/reels/chance/skeleton.json',
  'animations/spine/respin/skeleton.json',
  'animations/spine/transition/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
  'atlases/main-1.json',
]
export const particle = ['atlases/particle-0.json']
